define('routers/activities',["require", "subroute"], function (require, subroute) {
    "use strict";

    return Backbone.SubRoute.extend({
        initialize: function (options) {
            options = options || {};
        },
        routes: {
            /* matches http://payforward.com/activity */
            "": "showActivities",
        },
        before: function (route, params) {
            if (route) {
                var zaccess = checkAccess(route);
                if (!zaccess)
                    return false;
                if (!pf.isMobile()) {
                    if (route == "activity") {
                        var that = this;
                        store.getStoreItem(enums.modelsEnum.EmailVerificationPassed, null, false, false, false, function (data) {
                            that.EmailVerificationPassed = data;
                        });
                        if (that.EmailVerificationPassed == "1" && !(pf.IsConsumerFinancial || pf.IsZCardholder)) {
                            pf.navigate("wallet");
                            return false;
                        } else {
                            pf.globalEvents.trigger("Navigation:Changed", "activity");
                        }
                    }
                } else if (pf.session.get("auth") && pf.session.inApp && !(pf.IsConsumerFinancial || pf.IsZCardholder)) {
                    pf.navigate("finregister");
                }
            }
        },
        after: function (route, params) {
            if (route) {}
        },
        showActivities: function () {
            store.setStoreItem(enums.modelsEnum.CurrentContext, { Data: enums.HelpContext.Home });          
        }
    });
});

